import "../base.scss";
import "./notifications.scss";
import "./modal.scss";

/**
 * This is the new layout with CSS for the new UI pages only.
 * Older UI pages are rendered inside LegacyLayout which uses Bootstrap.
 */
const PageLayout = (props: any) => {
  return (
    <>
      <div className="PageLayout">{props.children}</div>
    </>
  );
};

export default PageLayout;
